import { tMissing } from '@/i18n/helpers';
import { footerItemGroups, useFooterItems } from '@/shared/config/footerItems';
import { IonCol, IonFooter, IonGrid, IonRouterLink, IonRow, IonText } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import Icon from '../Icon/Icon';
import styles from './Footer.module.css';
import _ from 'lodash';
import { useHistory } from 'react-router';
import contactInformation from '@/shared/config/contactInformation';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const footerItems = useFooterItems();

  const footerLinks = footerItemGroups.map((groupName) => {
    return (
      <div key={groupName}>
        <h6>{t(`footer.${groupName}`)}</h6>
        <ul>
          {footerItems[groupName].map(({ url, title }) => (
            <li key={title} className={styles.linksContainer}>
              <IonRouterLink
                href={url}
                target={_.startsWith(url, '/') ? '_self' : '_blank'}
                onClick={(evt) => {
                  if (_.startsWith(url, '/')) {
                    evt.preventDefault();
                    history.push(url);
                  }
                }}
              >
                {title}
              </IonRouterLink>
            </li>
          ))}
        </ul>
      </div>
    );
  });

  return (
    <IonFooter class="ion-no-border" className={styles.footer}>
      <IonGrid className={styles.content}>
        <IonRow>
          <IonCol size="12" sizeLg="6">
            <section className={styles.logoWrapper}>
              <span>{tMissing('Powered by')}</span>
              <IonGrid className={styles.footerLogoGrid}>
                <IonRow>
                  <IonCol sizeLg="2" size="6">
                    <a href={contactInformation.boerseStuttgartWebsite.url} target="_blank" rel="noopener noreferrer">
                      <Icon src={'assets/icons/bsg-logo.svg'} size="xxxlLarge" color="medium" />
                    </a>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </section>
          </IonCol>
          <IonCol size="12" sizeLg="3" pushLg="3">
            <section className={styles.linksWrapper}>{footerLinks}</section>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size="12">
            <IonText>{t('footer.noticeText')}</IonText>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size="12" sizeLg="10">
            <IonText>&copy;&nbsp;{t('footer.copyright')}</IonText>
          </IonCol>
        </IonRow>
      </IonGrid>
    </IonFooter>
  );
};

export default Footer;
